import { types } from "./types";

const initialState = {
  // forms: [],
  // internalObligations: [],
  navigateId: 0,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_INTERNAL_OBLIGATIONS.SUCCESS:
      return {
        ...state,
        forms: action.payload,
        internalObligations: action.payload
      };
    case types.SET_DOCUMENTS.SUCCESS:
      return {
        ...state,
        documents: action.payload
      };
    case types.CREATE_INTERNAL_OBLIGATION.SUCCESS:
      return state;
    case 'UPDATE_INTERNAL_OBLIGATION_FORMS':
      const updatedForms = [...state.forms];
        const updatedForm = {...updatedForms[action.payload.index]};
        updatedForm[action.payload.key] = action.payload.value;
        updatedForms[action.payload.index] = updatedForm;
        return {
            ...state,
            forms: updatedForms
        };
    case types.UPDATE_INTERNAL_OBLIGATION.SUCCESS:
      return state;
    case types.ASSIGN_INTERNAL_USER.SUCCESS:
      return state;
    case types.MASS_ASSIGN_INTERNAL_OBLIGATIONS.SUCCESS:
      return state;
    case types.DELETE_INTERNAL_OBLIGATION.SUCCESS:
      return state;
    case types.RESET_INTERNAL_OBLIGATIONS.SUCCESS:
      return initialState; // Resets the state to the initial state
    case 'SET_NAVIGATE_INTERNAL_ID':
      return {
        ...state,
        navigateId: action.payload
      }
    case 'CLEAR_NAVIGATE_INTERNAL_ID':
      return {
        ...state,
        navigateId: 0
      }
    default:
      return state;
  }
}

export default reducer;
